import React from "react";
import Baner from "../../assets/baner.png";
import Card from "./cards/Card";
import Leaf from '../../assets/leaf.svg';
import Individual from '../../assets/individual.svg';
import Health from '../../assets/health.svg';
import { Link } from "react-router-dom";

const Content = () => {
    return (
        <div className="flex flex-col items-center text-gray-900 px-4 pb-10 bg-blue md:px-20 relative">
            <div className="min-h-[360px] pt-5 pb-14 h-fit flex justify-center items-center max-w-2xl">
                <img src={Baner} className="" alt="baner" />
            </div>
            <div className="max-w-7xl pb-14">
                <h2 className="text-3xl font-bold text-green-main mb-4">Kim jesteśmy?</h2>
                <p className="mb-4">Gabinet terapii naturalnych <span className="text-green-main font-bold">Natur Med</span> to miejsce, w którym zdrowie i dobrostan stawiane są na <span className="text-green-main font-bold">pierwszym</span> miejscu. Wiemy, że ciało posiada naturalne zdolności do regeneracji, dlatego stosujemy holistyczne i indywidualne podejście do każdego pacjenta, dbając o równowagę organizmu.</p>
                <p className="mb-4">Oferujemy szeroki wachlarz terapii naturalnych, takich jak ziołolecznictwo, masaże lecznicze Bowena, aromaterapia, które wspierają zdrowie i odporność organizmu. W naszym gabinecie stawiamy na bezpieczne, naturalne metody i indywidualne podejście, dostosowując każdą terapię do potrzeb i celów zdrowotnych pacjenta.</p>
                <p><span className="text-green-main font-bold">Natur Med</span> to miejsce pełne spokoju i harmonii, gdzie każdy może odnaleźć drogę do wewnętrznej równowagi, poprawić jakość życia i zyskać wsparcie na drodze ku lepszemu zdrowiu. <Link to="/about-us" className="text-green-main hover:underline">Dowiedz się więcej</Link> o naszej ofercie.</p>
            </div>
            <div>
                <ul className="flex flex-col justify-center gap-6 md:flex-row max-w-7xl">
                    <Card
                        title="Profilaktyka zdrowotna"
                        content="Terapia naturalna zmniejsza ryzyko wystąpienia schorzeń i wzmacnia odporność organizmu."
                        icon={Health}
                        alt="health"
                    />         
                    <Card
                        title="Indywidualne podejście"
                        content="Każdy klient jest dla nas wyjątkowy. Dostosowujemy nasze metody do Twoich potrzeb."
                        icon={Individual}
                        alt="individual"
                    />
                    <Card
                        title="Naturalne metody"
                        content="Wspieramy ciało w powrocie do zdrowia bez użycia chemii i syntetycznych substancji."
                        icon={Leaf}
                        alt="leaf"
                    />         
                </ul>
            </div>
        </div>
    );
};

export default Content;